export function resolveReadingPassages(owner = {}) {
  if (Array.isArray(owner?.ReadingPassages) && owner.ReadingPassages.length) return owner.ReadingPassages;
  const text = String(owner?.ReadingPassage || '');
  const image = String(owner?.Image || '');
  if (!text && !image) return [];
  return [{ Title: 'Reading Passage', Text: text, Image: image, ImageAlt: owner?.ImageAlt || 'Reading passage image', ImageCaption: owner?.ImageCaption || '', Speech: owner?.ReadingPassageSpeech || '', Vocabulary: [] }];
}

export function passageOwner(kind, question, grade) {
  return kind === 'regular' ? question : grade;
}

export function passageContext(owner) {
  if (!Array.isArray(owner?.ReadingPassages) || !owner.ReadingPassages.length) {
    return String(owner?.ReadingPassage || owner?.Options?.ReadingPassage || '');
  }
  return resolveReadingPassages(owner)
    .map(item => `${String(item.Title || 'Reading Passage').trim()}\n${String(item.Text || '').trim()}`)
    .join('\n\n');
}

export function passagePlainText(value) {
  return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}
